import { Modal } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { reportsConstants } from 'locale/team'
import { useTranslation } from 'react-i18next'
import SafeguardingWarningAlert from '../../../../screens/Organisation/screens/TeamList/components/EditPermissionsPanel/SafeguardingWarningAlert'

type ProfileEditSafeguardingModalProps = {
  onClose: () => void
  open: boolean
  siteNames: string[]
  testId?: string
}

const ProfileEditSafeguardingModal = ({
  onClose,
  open,
  siteNames,
  testId
}: ProfileEditSafeguardingModalProps) => {
  const { t } = useTranslation(NAMESPACE.TEAM)

  return (
    <Modal
      localisation={{
        title: t(reportsConstants.SAFEGUARDING_MODAL_TITLE),
        confirmText: t(reportsConstants.SAFEGUARDING_MODAL_CLOSE)
      }}
      isModalVisible={open}
      onConfirm={onClose}
      onCancel={onClose}
      closeButton
      closeOnConfirm={false}
      testId={testId}
    >
      <SafeguardingWarningAlert variant="capability" siteNames={siteNames} />
    </Modal>
  )
}

export default ProfileEditSafeguardingModal
